// Quotes app content: edit the array to add new pages.
export const QUOTES_PAGES = [
  `Live what you want to tell.

Life shrinks or expands in proportion to one’s courage.

You’re gonna die.

Desire is a contract you make with yourself to be unhappy until you get what you want.

To the man with a hammer, every problem is a nail.

Self-esteem is the reputation that you have with yourself.

It’s much easier to fool them then to convince them that they were fooled.

When you eat shit, it’s better not to nibble.

I’m not gaslighting you, you’re just crazy.

Don’t do what will make you lie.

Restraining orders don’t work on the people you put restraining orders on.

Nobody goes there anymore, it's too crowded.

Life is the dance between what we love and fear most.

If you don’t have twenty minutes to delve into yourself and meditate, you really need two hours.

Hope is not a strategy.

What would you do if you know you couldn’t lose?

Dying tomorrow is not worse than dying on any other day.

We’re similar in the sense that each of us is the center of our universe.

Don’t cry over anything that can’t cry over you.

I stand accused of the things I’ve said. 

Be indifferent about things that make no difference.

Unease is the gap between between intent and action.

You control what you do,  you do what you want, and you can't control what you (want to)* want to do.

If something is out of context, it is for a reason.

Happiness is reality minus expectations.

If you look for something, you're only open to seeing that thing.

The less confident you are, the more serious you have to act.

Have you ever done, thought or felt anything outside of the now? Do you think you ever will?

Don’t be afraid to leave everything behind.

The problem with socialism is that you eventually run out of other people’s money.

If you know something a week before others, you’ll be stupid for a week.

If you have a plan and you don’t practice it, you might as well not have a plan at all.

There are no problems, only situations.

You invoke the universe when you say your name.

We often say next time.. not knowing that the next times are far more spread out than we imagine.

If you’re so smart, why aren’t you happy?

Don’t be fooled by proxies. 

If there was an answer, we would not be free.

If you can't program it, you don't understand it.

Suffering is when you see reality as it is.. we push off reality bc we are biased to avoid pain.

Whenever you find yourself on the side of the majority, it's time to pause and reflect.

The only true test of intelligence is that you get what you want out of life.

Process saves us from the poverty of our intentions.

Don’t threaten a whore with a dick.

Sugar and salt look the same. 

You won’t do anything great by doing what others do, living like others live. 

Just because you’re not ready for the day, doesn’t mean it can always be night. 

Though life is short in the grand scheme of everything, from our eyes it is very long. Make decisions for the long term. (compound interest) Unless you'll be stuck living a life that you don't respect.

Memento mori— “remember that you have to die.” All of this will go to nothing. Remember before you were born? Just like that. 

Forgiveness is accepting the apology you will never receive.

People aren't saying anything of weight if nobody would go up on stage and say the opposite.

Want the solution to the answer? That’s for you to figure out. It’s about the process: ensure the process is right to the extent that you’re sufficed.

Even if you are not ready for the day, it can not always be night.

Buddhist novelist George sanders - has an image of people’s “nectar in decaying containers”.

Every day you wake up; deliberately or not, you choose the situation you’re i

Everybody should be under one time zone. Keep it simple. Should June be “December” in Brazil just because it is winter?

To measure the quality of your life, simply do nothing, and see how it feels.

Hard choices, easy life. Easy choices, hard life. 

Treat people for who they CAN be.

I apologize for the long letter, I didn't have time to make it shorter.

The struggle ends when the gratitude begins.

Your life is a series of endless choices.

Things are never as good or as bad as they seem.

Life is tough, and it’s tougher if you’re stupid

Try to change your mind about something every day.

Don’t be afraid of being wrong. Because being wrong is just an opportunity to find more of the truth

What makes a river so restful to people is that is does not have any doubt. It is sure to get where it’s going, and it doesn’t want to go anywhere else 

Life is fucking beautiful.

Do not be subject to inertia.

Challenge your assumptions and the assumptions of those around you as a way of life 

A man who had committed a mistake, and does not fix it, has created another mistake.

Any emotion is better than no emotion.

A character, after death, only sees flowers as blobs of color, and his spirit guide tells him, “That’s because you never really looked at them when you were alive.”

Addiction is the progressive narrowing of the things that bring you pleasure.

I feel like my back is up against the wall. I loads of pressure coming in, and either my back or the wall is set to break. I want to load up some more pressure and see what happens.

If I had an hour to figure out a problem, I’d spend 55 minutes thinking about the problem and 5 minutes thinking about solutions.

Don’t lie, and you’ll never have to remember what you said.

We’re all devoted curators [of our lives].

Do something new every day. 

Not I hope they like me. I hope I like them. 

Any truths I maintain are my own property.

People feel they are the appropriate mix of what makes for a good person, and if not, they are unsastisfied.

The fool, with his other traits, has this also: he is always getting ready to live. 

Morality is founded in our emotions. 

Move fast and break things.

How do you know that you were an amoeba? Evolution? You’re pressured into it. You’re crazy if you don’t, yet the people judging don’t know the details.  Who’s crazy?

Your world is a reflection of your world within.

To be a phoenix, you have to burn.

You’re worried of a feeling.

Don’t think about the comfort of action, think of the discomfort of inaction 

Imagine having to relive your day for the rest of your life.. would you have had a good life ?

If you don’t fear the unknown, the unknown will be kind to you.

You decide who you are at every moment. An infintecimate amount of choices. 

The answers are there for those who seek.

"Your network is your net worth." - Mason Mastrov

Think about any situation you’ve been in. Now think about it without any fears or desires. Think about how simple it is.

Imagine an angel comes to you.. says time to set up your affairs. You’re going to be coming with me. You resist, and say you want another week. Well, what’ve you been doing with the rest of your life.. what happened? I wasn’t paying attention. That’s one hell of a thing to say about your life. 

Learn what makes someone feel important, and you learn who they are. 

Being a counter-indicator is an odd position.. no matter what you do you’re wrong. Switch? That’s the wrong decision. 

The gap between deontology and utilitarianism is illusory.

Activities tend to fill the time they are allotted (Parkinson’s Law).

Resentment is like drinking poison and waiting for the other person to die 

Every man has a right to property [in his own person].

Being present isn't ignoring the past or future.. the past and future are only exhibited in the present.

You are attached. To something or to nothing. Perfectly random inputs [in your environment], or an unknown state of being, is necessary.

[Universal Answer Paradox] 
There are no dichotomies.. 
To work backwards is to assume you're right.. & by definition irrational [ logic absent ]
For any single dichotomy, to be considered true, all must not only be accounted for, but clearly and consistently reasoned. 
Out of these, only one can be True, or else they are the same.

There can only be one truth.

Be ware of the 37% Rule.

The more time you develop yourself-intellectually, emotionally, spiritually, physically- the more you narrow the selection of suitable long-term partners.

A trial is a giving of yourself. Huge effect on your consciousness is to be concerned. 

If a girl leans in to kiss you after felacio, do you concede?

Happiness is how one feels when things are going well.

We fall insensibly into dangerous situations, from which we could easily have safeguarded ourselves, but from which we cannot withdraw without heroic efforts which appal us. So finally, as we tumble into the abyss, we ask God why he has made us so feeble. But, in spite of ourselves, He replies through our consciences: 'I have made you too feeble to climb out of the pit, because I made you strong enough not to fall in.'

The world is highly inefficient. People use the nearest multiple of 5 as a marker.. what’re the odds that’s actually the most effective?

Read all of the books—forget the sources.. and you’re a genius. 

Great spirits have always faced opposition from mediocre minds. 

Argue like you’re right. Listen like you’re wrong. 

Is it possible to prove absence ?

To enjoy the world.. or to improve the world. 

When he saw the breadth of his domain, he wept, for there were no more worlds to conquer. 

Prove you have free will. 

Subjectivity comes from bias. 

Complexity is a blessing. Simplicity is freedom. 

Many a false step was made by standing still.

Most people choose unhappiness over uncertainty. 

There’s no difference between a pessimist who says, ‘Oh, it’s hopeless, so don’t bother doing anything,’ and an optimist who says, ‘Don’t bother doing anything, it’s going to turn out fine any way.’ Either way, nothing happens. - 

Story of the Chinese farmer. Maybe. 

Contemplate the life of a social entrepreneur. (Look into Peter Singer.)

Everything you do, you did be cause you thought it was your best option, for any reason. - Plato

Every person is one decision away from disaster.

The mind-body problem. Interesting people will be 

Ridicle for self-plagarism will be soon be un-understood.

It’s getting harder to fight submission — be raw & be defiant to be of value.

I don't ever want to fail, but I want to risk failure every time out of the gate.

Those entrenched in expectations will eventually rationalize [un]fulfillment. 

Questions to stimulate the idea that consciousness can be solely claimed by humans: how do you think humans obtained consciousness? how would this look being applied to others? how does this make you feel? is the bias warranted? who do I want to be? what do I believe I can be?

The harder I work, the luckier I get. 

Problems are questions that have not been answered. Premise in the form of an antecedant.

You can't solve a problem with the mind that created it.

Do what you love and let it kill you.

What can happen if everything goes right?

To be brave, there needs to be fear.

You reap what you sow. "Fairly blunt, hopefully clear." 

Growth is happiness. You are lucky if you didn’t start at the top. 

Your audience is not yourself. 

Martin Luther King and Emelia Earhart never had a computer, but if they did, you know they would’ve used a Mac.

Set your boundaries, and have those difficult conversations.

Show me the incentive, and I will show you the outcome.

Strong opinions, loosely held. 

To a disciple who was forever complaining about others, the Master said, ‘If it is peace you want, seek to change yourself, not other people. It is easier to protect your feet with slippers than to carpet the whole of the earth.’

The tremendous price (of competition) is that you stop asking some bigger questions ... don't always go through the tiny little doors that everyone tries to rush through, maybe go around the corner, go through the vast gate no one is taking.

What risk actually looks like is not doing something; when you may spend the rest of your life regretting it.

People regret things that they didn't do more than things they did.

I haven't failed. I've just found 10,000 ways that don't work.

"God's greatest gift is creating doubt." - Dad

If I’m only for myself, who will be for me? If not now, when? If I’m only for myself, what am I? - Hillel 

Swing at the strikes.

A ship in a harbor is safe, but that’s not what ships are built for. 

One in a million is more than enough. 

You’ve seen your point of view, and are limited to rationally make assumptions from your experience.. expecting others to do the same. 

During a cattle competition at the beginning of the 20th century, a guy named Francis Galton saw that no single person could consistently guess within a range of a cattle's weight, though the average of the crowd's guesses were amazingly accurate.

Trust is build one marble at a time.

Optimism is a force multiplier.

Jump and realize that the net is you.

The fear of change founds the fear of death.  

It’s not how about well you’re doing, but how long you’re doing well. 

Does your decision shrink or expand your options?

Cowards die many times before their deaths; the valiant never taste of death but once.

Avoiding judging through understanding.

What's profound is that you make an amount of decisions to choose the same path every day, an amount that dwarfs any change, yet a single rash and adventurous decision to change your environment unlocks a path that holds entirely new experiences.

Losing the right game can be better than winning the game in front of you. 

You are whoever you pretend to be. 

According to this history book here, the good guys won. 

There’s always room at the top. 

If you fail, it doesn’t mean you are wrong. 

You are what the universe is doing where you are sitting. 

Good days give happiness, bad days give experiences, the best days give memories, and the worst days give experiences. 

If present you doesn’t want to do it now, future you won’t want to do it later. 

If you don’t learn to love the snow, you’ll have less joy in your life and the same amount of snow. 

A great man is hard on themself, a weak man is hard on others. 

Humans are built on stories, and stories are only the digestible chain of events. 

Innate instincts and fears are passed down from ancestors. 

It is better to do something and regret it, than it is to stay quiet and regret it.   

I can calculate the motions of heavenly bodies, but I cannot understand the madness of men. 

The magic you are looking for is in the work you are avoiding. 

If matter cannot create activity, then activity must come from the mind. (Inertia)

Behind every no is a deeper yes. 

Go back to beginning, find the ideas that didn’t make it. 

If you truly love something, let it go. 

Specialization is for insects. 

50% of the time, it works every time.

Imagine the scenarios, and pick the coolest one. 

Truth is usually seen, rarely heard. 

If I could be good or lucky, I’d take lucky. 

We don’t make mistakes, only happy little accidents.

Become a unicorn. 

The risk is regret. 

Prediction is very difficult, especially about the future. 

Whether you think you can or think you can’t—you’re right.

When the data and the anecdotes disagree, the anecdotes are usually right.

Yes is usually counterfeit. It’s aspirational at best without the how.

Learn the rules like a pro, so you can break them like an artist. 

The reward for our work is not what we get, but what we become. 

They’re putting privacy perfume on without taking a shower. 

Life is just one damn relatedness after another.

Kids don’t understand danger, they understand fear. 

A friend is virtuous as long as they benefit you. 

The price of liberty is vigilance.

Teaching is controlling what you focus on. 

Everything you think you know is based off of a belief. 

Political philosophy should be a core subject. 

Don’t count when you’re working out. 

If you could travel back in a time machine, one thing would be true no matter where you went: you'd have to watch what you said.

Mapmakers deliberately put slight mistakes in their maps so they can tell when someone copies them.

Consequentialist debates ignore the far out consequences that come from immorality. 

The stock market is a device for transferring money from the impatient to the patient. 

How you spend your time is how you live your life.

The darkness to your life is the compass to your purpose. 

Pressure makes diamonds. 

Don’t be proud of what you consume. Be proud of what you create.

Trust doesn’t scale.

If more information were the answer, we’d all be billionaires with 6 pack abs.

Simply knowing someone is watching is enough to alter your actions. Akin to the concept that donors [for research studies] do not need to explicitely state their interests.

Until you make the unconscious conscious, it will direct your life and you will call it fate. 

Read everything you can, forget the sources, and you’re a genius. 

If I’m not here, I’m somewhere else. 

Like a pig with lipstick. 

If you don't become the ocean, you'll be seasick everyday.

Provide a platform for [crazy] people who've been through experiences others don't believe, and should hear.

It's much easier to fool a man than it is to convince him he's been fooled.

Whenever you find yourself on the side of the majority, it is time to reform.

He who has a why can bear almost any how. 

You don’t wanna own the Ferrari, you wanna own the feeling of owning a Ferrari. 

Create a society that rewards people who do good.

All great artists are thieves. 

Do the job before you get it. 

If you want to be loved, be lovable. 

You can fit a round peg in a square hole. 

Marble story, averages of sums. 

Knowledge gives you the tools to make a contextual decision.

What would it look like if you were wrong?

The opposite of love isn’t hate, it’s indifference. 

You will fail if you do not learn the right skills. 

It doesn’t matter if it’s a white cat or a black cat, as long as it catches mice. 

Religious people befriend you as if they don’t believe that you’re going to hell. 

Evolution and growth is happiness and where we find duty and purpose is through passing this tribal knowledge and experience down through genetics and teaching. This is the why. 

Argue like you’re right, listen like you’re wrong. 

Under capitalism, man exploits man. Under communism it’s just the opposite. 

Yesterday’s a lesson, today’s a blessin. 

You do not achieve yours dreams, you achieve your standards. 

What land hasn’t been stolen?

Power wash a stencil/outline of your ad [into the sidewalk]. 

It is what it is.

If you want to go fast, go alone. If you want to go far, go together. 

I removed everything that was not David. - Michelangelo 

The road to hell was paved with good intentions. 

You are never going to experience this version of you ever again. 

I have a problem and I like having a problem. 

The man who does more than he is paid for will soon be paid for more than he does. 

Until death all defeat is psychological.

Who are you gonna believe. me, or your lying eyes?

Constraints inspire creativity.

Comparison is the death of joy.

JOMO - joy of missing out.

Why read fiction? The world is interesting enough.

Everything you want is on the other side of fear.

If art imitates life, then if you want to create art, you need to have a life.

A distinction without a difference.

If you can’t be happy with what you have, nothing you get will make you happy.

What you understand, will change.

Absolute power corrupts absolutely.

Don’t argue with an idiot — they’ll drag you down and beat you with experience.

You get to.

You cannot teach a man anything. You can only help him discover it within himself.

Fate is what you are given. Destiny is what you make of it.

You don't lack the resources.. you lack the resourcefulness. Be resourceful.

Give yourself that favor.

It should never be a crime to NOT do something.

Equalizer: Conspiracyyy...

People that say money doesn’t buy happiness don’t know where to shop.

In a world of infinite leverage, judgement, not hard work, will determine success.

Good leaders are right a lot.

We pretend to work, and they pretend to pay us.

One death is a tragedy, a million deaths is a statistic.  

You’re not oppressive until you are.

Healthy mind. Healthy body. Healthy heart.

In every work of genius we recognize our own rejected thoughts; they come back to us with a certain alienated majesty.

Philosophical zombie problem: Why are we conscious? Why aren't we zombies that can talk, act, and do what you're doing right now? Why are we conscious?

While I was considering writing this (while watching a video), I told myself that I could wait until the next time my mind is free to write the very idea that was plaguing me down and examples thereof. THE NEXT TIMES ARE FEW AND FAR BETWEEN. that’s if they come, and if they do, you’re back to the same “dilemma”. Just fucking do it.

Row row row your boat, gently down the stream.

Everything counts.

Humans think linearly. A million minutes ago is a week. A billion is a few years. A trillion is 35 billion minutes ago.

The whole of psychology can be boiled down to one concept: people move towards pleasure and away from pain.

We are a universal self. What the fuck. We are all the same. We are the same as the trees if we were a tree.

Not questioning what you believe is called dillusion.

Consumers are divinely discontent. Their expectations are never static - they go up. It's human nature. We didn't ascend from our hunter-gatherer days by being satisfied. People have a voracious appetite for a better way, and yesterday's 'wow' quickly becomes today's 'ordinary'.

New information starts as misinformation.

If you can’t be used, then you’re useless.

Crush 'em to the point that they rely on you.

We are but a expression of our planet.

If everyone agrees with you, then you are not saying anything interesting.

A man who fears pain more than failure will taste both.

It’s much easier to fool someone than to convince them they’ve been fooled.

Early to bed, early to rise, makes a man healthy, wealthy, and wise.

You undervalue advice from the people closest to you.

Sometimes you need to stop doing things you love in order to nurture the one thing that matters most.

It can always be worse.

When punishment for a crime is fine, it’s a crime for poor only.

Better technology makes more better jobs for horses.

If you’re so smart, then why aren’t you happy?

We fight tooth and nail to maintain our conceptual schemes. Literally kill each other, or we are tame enough to pretend to not be enraged.

One can be biased and correct.

You can’t reason someone out of a notion they didn’t reason into.

To let new stuff in, you must let old stuff out.

You want me to feel sorry? You want me to feel bad?

It sure is cold, but at least it’s windy.

Train the body rigorously so that it will not be disobedient to the mind.

Fate loves irony.

What would it look like if this was the beginning of something much larger?

Don’t answer the question they asked - answer the question you wish they asked.

Different AI models, when asked to come up with a random number, provide the same random number. 47 atm.

Inject randomness into your life. Know your unknowns.

Anxiety is downstream of inaction.

Everywhere you go, there you are.

The more corrupt the state, the more numerous the laws. 

If you want to persuade an intelligent being, you have to be able to be persuaded. 

We overestimate what we can do in a week, and we underestimate what we can do in a year.

In the land of the blind, the one-eyed man is king.
`,
];
